import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=1b14be7d&scoped=true&"
import script from "./Recorder.vue?vue&type=script&lang=js&"
export * from "./Recorder.vue?vue&type=script&lang=js&"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=1b14be7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b14be7d",
  null
  
)

export default component.exports